import React, { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { useSession } from "../../hooks/session";

import { TransactingComponent } from "../../types/general";
import style from "./style";
import useStyles from "../../hooks/styles";
import { useNetwork } from "../../hooks/network";
import {
  DEFAULT_LIQUIDITY_PATH,
  DEFAULT_REMOVE_LIQUIDITY_PATH,
  getLiquidityPath,
} from "../../tradeRouting";

interface NavTabProps {
  label: string;
  href: string;
}

function NavTab(props: NavTabProps) {
  const navigate = useNavigate();
  return (
    <Tab
      sx={{}}
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        navigate(props.href);
      }}
      {...props}
    />
  );
}
export interface INavLiquidty {
  scalingKey?: string;
}
export const NavLiquidity: FC<INavLiquidty> = (props) => {
  const styles = useStyles(style, props.scalingKey);
  const [value, setValue] = useState(0);

  const sessionInfo = useSession();
  const network = useNetwork();
  useEffect(() => {
    switch (sessionInfo.activeComponent) {
      case TransactingComponent.SWAP:
        setValue(0);
        break;
      case TransactingComponent.ADD_LIQUIDITY:
        setValue(0);
        break;
      case TransactingComponent.REMOVE_LIQUIDITY:
        setValue(1);
        break;
    }
  }, [sessionInfo]);
  /*
  useEffect(() => {
    if (loading) {
      navigate("home/swap");
      setValue(0);
      setLoading(false);
    }
  }, [loading, navigate]);
  */

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    event.preventDefault();
    setValue(newValue);
  };
  const addHref = network.selectedPool
    ? getLiquidityPath(network.selectedPool)
    : DEFAULT_LIQUIDITY_PATH;
  const removeHref = network.selectedPool
    ? getLiquidityPath(network.selectedPool, "remove")
    : DEFAULT_REMOVE_LIQUIDITY_PATH;
  return (
    <Tabs
      value={value}
      sx={styles.navLiquidity}
      onChange={handleChange}
      aria-label=" "
      TabIndicatorProps={{
        children: (
          <span
            className={
              value === 0
                ? "MuiTabs-indicatorSpan-add"
                : "MuiTabs-indicatorSpan-remove"
            }
          />
        ),
      }}
    >
      <NavTab label="Add Liquidity" href={addHref} />
      <NavTab label="Remove Liquidity" href={removeHref} />
    </Tabs>
  );
};
